import React from "react";
import { Link } from "react-router-dom";
import SsoLoginCallBack from "Utils/SsoLoginCallBack";



const SsoCallBackFacebook = () => {
    SsoLoginCallBack("facebook");
    return(
        <>
        </>
    )
}

export default SsoCallBackFacebook;